import { SyncSettings as TcpsSyncSettings } from '../../generated/index';
import { SyncFilter, SyncSettings } from '@trimble/types';

export const mapToTcpsModel = (input: SyncSettings): TcpsSyncSettings => ({
  projectId: input.projectId,
  syncMode: input.syncMode,
  filters: input.filters.map((filter) => ({
    id: filter.id,
    description: filter.description,
    checked: filter.checked,
  })),
});

export const mapToDomain = (input: TcpsSyncSettings): SyncSettings => ({
  projectId: input.projectId,
  syncMode: input.syncMode,
  filters: input.filters.map(
    (filter): SyncFilter => ({
      id: filter.id,
      description: filter.description,
      checked: filter.checked,
    })
  ),
  // These settings do not exist in TCPS SyncSettings, setting defaults
  allowAutoCheckout: false,
  requireCheckoutForUpload: false,
  requireCheckoutForUploadMakeReadonly: false,
});
